module.exports = __webpack_public_path__ + "static/media/practice-question-header.36f23d54.png";